import { gql, useQuery } from '@apollo/client'

const GET_CORE_LOCALES = gql`
  query {
    getCoreLocales {
      coreLocales {
        nodes {
          code
          languageDescription
        }
      }
    }
  }
`

interface CoreLocalesPayload {
  getCoreLocales: {
    coreLocales: {
      nodes: { code: string; languageDescription: string }[]
    }
  }
}

export function useGetLocalesAndLanguageDescriptions() {
  const { data } = useQuery<CoreLocalesPayload>(GET_CORE_LOCALES)
  return data?.getCoreLocales.coreLocales.nodes || []
}